import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} DropdownProps
 */

/**
 * Dropdown Dropdown.
 * @augments {Base<DropdownProps>}
 */
export default class Dropdown extends Base {
  isOpen = false;

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Dropdown',
    refs: ['btn', 'close[]', 'dropdown', 'input'],
    emits: ['open'],
  };

  /**
   *
   */
  onCloseClick() {
    this.close();
  }

  /**
   * Stop propagation when click in the element
   * @param {object} props Props
   * @param {Array} props.event current event
   * @returns {void}
   */
  onClick({ event }) {
    event.stopPropagation();
  }

  /**
   * Close when clicking outside the element
   * @returns {void}
   */
  onDocumentClick() {
    this.close();
  }

  /**
   *
   */
  onBtnClick() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  /**
   *
   */
  open() {
    this.$emit('open', this);
    this.isOpen = true;
    this.$refs.btn.classList.add('s:bg-white', 's:shadow-custom');
    this.$refs.dropdown.classList.add('dropdown--active');
  }

  /**
   *
   */
  close() {
    this.isOpen = false;
    this.$refs.btn.classList.remove('s:bg-white', 's:shadow-custom');
    this.$refs.dropdown.classList.remove('dropdown--active');
  }
}
